"use client"

import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { CheckIcon, PlusIcon } from "lucide-react"
import * as React from "react"

import { cn } from "@/utils/styles.helpers"

interface CheckboxProps
	extends Omit<React.ComponentProps<typeof CheckboxPrimitive.Root>, "checked"> {
	checked?: boolean | "indeterminate" | "select-all"
}

function Checkbox({ className, checked, ...props }: CheckboxProps) {
	// Convert our custom checked states to what CheckboxPrimitive expects
	const primitiveChecked =
		checked === "select-all"
			? true
			: checked === "indeterminate"
				? "indeterminate"
				: checked
	const isSelectAllVariant = checked === "select-all"

	return (
		<CheckboxPrimitive.Root
			data-slot="checkbox"
			className={cn(
				"peer border-input dark:bg-input/30 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground dark:data-[state=checked]:bg-primary data-[state=checked]:border-primary data-[state=indeterminate]:bg-primary data-[state=indeterminate]:text-primary-foreground dark:data-[state=indeterminate]:bg-primary data-[state=indeterminate]:border-primary focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive size-4 shrink-0 rounded-[4px] border shadow-xs transition-shadow outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50",
				isSelectAllVariant &&
					"data-[state=checked]:bg-teal-700 data-[state=checked]:border-teal-700 dark:data-[state=checked]:bg-rose-900 dark:data-[state=checked]:border-rose-900",
				className,
			)}
			checked={primitiveChecked}
			{...props}
		>
			<CheckboxPrimitive.Indicator
				data-slot="checkbox-indicator"
				className="flex items-center justify-center text-current transition-none"
			>
				{checked === "indeterminate" ? (
					<div className="w-2 h-0.5 bg-current" />
				) : checked === "select-all" ? (
					<PlusIcon className="size-3.5 text-white" strokeWidth={2.5} />
				) : (
					<CheckIcon className="size-3.5" />
				)}
			</CheckboxPrimitive.Indicator>
		</CheckboxPrimitive.Root>
	)
}

export { Checkbox }
